/**
Объект с описанием онтологии
Содержит данные OWL в виде, удобном для работы в js
Загружается в приложение с сервера.
На сервере динамически на лету создается из OWL.
Или генерится отдельным скриптом и кэшируется как статик файл.
*/
const Ontology = {

	// типы преставлений 
	classes: [
		{
			// uri и название типа
			id: 'table', name: 'Таблица',
			// описание свойств, по котрому будет строиться форма редактирования
			props:[
				hide_in_list(),
				view_title('Новая таблица'), 
				view_description(), 
				src_endpoint(), 
				page_size(),
				src_query(),
				columns('table'),
				border_table(),
				border_width(),
				border_color()
			]
		},{
			id: 'list',	name: 'Список',
			props:[
				hide_in_list(),
				view_title('Новый список'),
				view_description(), 
				src_endpoint(), 
				page_size(),
				src_query(),
				columns('list'),
				borders(['empty', 'table', 'rows']),
				border_width(),
				border_color()
			]
		},{
			id: 'tree',	name: 'Дерево',
			props:[
				hide_in_list(),
				view_title('Новое дерево'),
				view_description(), 
				src_endpoint(), 
				page_size(),
				_positiveInteger(
					'tree_width',
					'Ширина дерева, %',
					{
						default:     100,
						restriction: {
							minCardinality: 0,
							cardinality:    1
						}
					}
				),
				_required_string(
					'src_query',
					'Запрос SPARQL корневых узлов дерева',
					{
						restriction: {
							multiline: true
						},
						comment: 'Запрос должен возвращать как минимум ?URI'
					}
				),
				link_column('link_view', 'Связанное представление', 'views'),
				columns('tree'),
				src_query_children(),
				borders(['empty', 'table']),
				border_width(),
				border_color(),
			]
		},{
			id: 'graph', name: 'Граф',
			props:[
				hide_in_list(),
				view_title('Новый граф'),
				view_description(),
				src_endpoint('endpoint'),
				_required_string(
					'graph',
					'Имя графа'
				),
				src_query('sparql', null),
				_boolean('typeAsSuperClass', 'Тип определяет родительский класс', false, true),
				_string(
					'show_type',
					'Тип отображения',
					{
						default:     'emd',
						restriction: {
							cardinality: 1,
							enumeration: ['emd', 'owl', 'sparql']
						}
					}
				),
				graph_uris('typesFilter',  'Список uri, которые будут отображаться узлами'),
				graph_uris('linksFilter',  'Список uri, которые будут отображаться рёбрами'),
				graph_uris('labelsFilter', 'Список uri, которые содержат метки'),
				graph_uris('createTypes',  'Типы, которые надо создавать'),
				_required_string('namespaces', 'Cписок пространства имён'),
				_optional_string('extra_options', 'Строка дополнительных настроек'),
			]
		},{
			id: 'multi', name: 'Набор',
			props: [
				hide_in_list(),
				view_title('Новый набор'),
				opt_view_description(),
				{
					id:    'views',
					name:  'Следующий элемент набора',
					type:  'object',
					props: [
						link_column('view', 'Отображаемое представление', 'views'),
					],
					restriction: {
						minCardinality: 1
					}
				},
			]
		},{
			id: 'html', name: 'Материалы',
			props: [
				hide_in_list(),
				view_title('Новые материалы'),
				opt_view_description(),
				_required_string(
					'html_code',
					'Произвольный html код',
					{
						restriction: {
							multiline: true
						},
					}
				),
			]
		},
		{
			id: 'cmp', name: 'Сравнение',
			props: [
				hide_in_list(),
				view_title('Новое сравнение'),
				opt_view_description(),
				src_endpoint(),
				page_size(),
				src_query('src_query', 'Укажите в запросе %CMP_FROM% - что сравнить, %CMP_TO% - с чем сравнить.'),
				link_column('graph_list', 'Список графов для сравнения', 'views'),
				columns('table'),
				border_table(),
				border_width(),
				border_color()
			]
		},
		{
			id: 'exporter', name: 'Экспортёр',
			props: [
				hide_in_list(),
				view_title('Новый экспорт'),
				opt_view_description(),
				src_endpoint(),
				_required_string('gen_endpoint', 'Эндпойнт генератора'),
				exporter_params(
					'sparqls',
					'SPARQL запросы с параметрами',
					{
						var_name: 'Имя переменной',
						query:    'Тело запроса'
					}
				),
				exporter_params(
					'templates',
					'Шаблоны с параметрами',
					{
						file_name: 'Имя файла',
						content:   'Содержимое файла'
					}
				),
				_string(
					'gen_type',
					'Тип генерации',
					{
						default:     'html',
						restriction: {
							cardinality: 1,
							enumeration: ['html', 'word']
						}
					}
				),
			]
		},
	]

};

export default Ontology;

// толщина рамки
function border_width() {
	return _positiveInteger(
		'border_width', 
		'Толщина рамки, пикс', {
			default:     1, 
			restriction: {
				cardinality: 1
			}
		}
	);
}

// Цвет рамки
function border_color() {
	return color(
		'border_color', 
		'Цвет рамки', 
		'#000000'
	);
}

function columns(type) {
	const props = [];

	props.push(_required_string('col_field', 'Поле данных',     {editable: false}));
	props.push(_optional_string('col_data',  'Пример значения', {editable: false}));
	props.push(_boolean(        'col_uri',   'Поле с URI',      true, false));
	props.push(_boolean(        'col_show',  'Отображать поле', type !== 'table', false));
	if (type !== 'tree') {
		props.push(_boolean(        'alpha_col', 'Поле для АУ', true, true));
		props.push(_required_string('col_title', 'Заголовок колонки'));
	}
	props.push(link_column('link_col', 'Ссылка', 'columns'));
	if (type === 'table') {
		props.push(_boolean('col_html',              'Выводить как HTML', false, true));
		props.push(_boolean('col_group',             'Группировать по полю', false, true));
		props.push(_optional_string('col_separator', 'Разделитель при объединении', {default: '" "'}));
		props.push(_optional_string('col_width',     'Ширина колонки'));
		props.push(_optional_string('col_width_min', 'Минимальная ширина колонки'));
	}
	props.push(color(      'col_foreground', 'Цвет шрифта', '#000000'));
	props.push(color(      'col_background', 'Цвет фона',   '#ffffff'));
	props.push(font_size(  'font_size',      'Размер шрифта, пикс '));
	props.push(font_style( 'font_style',     'Начертание шрифта'));
	props.push(font_weight('font_weight',    'Насыщенность шрифта'));
	if (type !== 'tree') {
		props.push(alignment('alignment',  'Выравнивание'));
	}
	return {
		id:          'col',
		name:        'Отображение данных',
		type:        'object',
		props:       props,
		restriction: {
			minCardinality: 1
		}
	};
}

function link_column(id, name, fill) {
	const props = _string(
		id,
		name,
		{
			default:     'нет',
			fill:        fill,
			restriction: {
				minCardinality: 0,
				cardinality:    1,
				enumeration:    ['нет'],
			}
		});
	if (fill === 'views') {
		props.restriction.selectSize = 5;
	}
	return props;
}

// заголовок view
function view_title(defval) {
	return _required_string(
		'view_title', 
		'Название представления',
		{
			default: defval
		});
}

// описание view
function view_description() {
	const props = opt_view_description();
	props.restriction.minCardinality = props.restriction.cardinality = 1;
	return props;
}

function opt_view_description() {
	return _optional_string(
		'view_description',
		'Описание представления',
		{
			restriction: {
				multiline: true
			}
		});
}

// эндпойнт запроса
function src_endpoint(id) {
	return _required_string(
		id || 'src_endpoint',
		'Эндпойнт запроса');
}

// запрос
function src_query(id, comment) {
	const src_query = _required_string(
		id || 'src_query',
		'Запрос SPARQL', 
		{
			restriction: {
				multiline: true
			}
		}
	);
	if (comment !== undefined) {
		src_query.comment = comment;
	} else {
		src_query.comment = 'Запрос должен возвращать как минимум ?URI';
	}
	return src_query;
}

// запрос дочерних элементов дерева
function src_query_children() {
	const query = _required_string(
		'src_query', 
		'Запрос SPARQL дочерних узлов дерева',
		{
			restriction: {
				multiline:   true, 
				cardinality: 1
			},
			comment: 'Запрос должен возвращать как минимум ?URI и ?PARENT_URI.' +
			' Для подстановки id родительского узла используйте ?PARENT_URI'
		}
	);
	return {
		id:    'subtree',
		name:  'Следующий уровень дерева',
		type:  'object', 
		props: [
			query,
			link_column('link_view', 'Связанное представление', 'views'),
			columns('tree')
		],
		restriction: {
			minCardinality: 1
		}
	}
}

// количество записей на странице таблицы или списка
// целое, неотрицательное, обязательное, по умолчанию 10, 0 означает отсутствие лимита.
function page_size() {
	return _nonNegativeInteger(
		'page_size', 
		'Количество возвращаемых записей', 
		{ 
			default:     10, 
			restriction: {
				cardinality: 1
			},
			comment: 'Используется для постраничного просмотра. 0 - возвращаются все записи.'
		}
	);
}

// цвет
function color(id, name, defval) {
	return _string(
		id, 
		name, 
		{
			default:     defval, 
			restriction: {
				cardinality: 1,
				pattern:     '#[0-9A-Fa-f]{6}'
			}
		});
}

// выравнивание
function alignment(id, name) {
	return _string(
		id, 
		name, 
		{ 
			default:     'left',
			restriction: {
				cardinality: 1, 
				enumeration: ['left', 'center', 'right']
			}
		});
}

// размер шрифта
function font_size(id, name) {
	return _positiveInteger(
		id, 
		name, 
		{ 
			default:     10, 
			restriction: {
				cardinality: 1
			}
		});
}

// начертание шрифта
function font_style(id, name) {
	return _string(
		id, 
		name, 
		{ 
			default:     'normal',
			restriction: {
				cardinality: 1, 
				enumeration: ['normal', 'italic']
			}
		});
}
// насыщенность шрифта
function font_weight(id, name) {
	return _string(
		id, 
		name, 
		{ 
			default:     'normal',
			restriction: {
				cardinality: 1, 
				enumeration: ['normal', 'bold']
			}
		});
}

// разные варианты бордюров
function borders(types) {
	return _string(
		'border',
		'Рамка',
		{
			default:     'empty',
			restriction: {
				cardinality: 1,
				enumeration: types
			}
		}
	);
}

// бордюр в таблице
function border_table() {
	return borders(['empty', 'table', 'rows', 'cells']);
}

// настройки элементов графа
function graph_uris(type, name) {
	const props = [];

	props.push(_required_string('uri', 'URI'));
	if (['typesFilter', 'labelsFilter'].includes(type)) {
		props.push(color('backgroundColor', 'Цвет фона', '#ffffff'));
	}

	return {
		id:          type,
		name:        name,
		type:        'object',
		props:       props,
		restriction: {
			minCardinality: 1,
		}
	};
}

function hide_in_list() {
	return _boolean('hide_in_list', 'Не показывать в общем списке', false, true);
}

function exporter_params(id, name, props) {
	const _props = [];

	_props.push(_required_string(Object.keys(props)[0], Object.values(props)[0]));
	_props.push(_required_string(Object.keys(props)[1], Object.values(props)[1],
		{
			restriction: {
				multiline:   true,
				cardinality: 1
			}
		}
	));

	return {
		id:    id,
		name:  name,
		type:  'object',
		props: _props,
		restriction: {
			minCardinality: 1
		}
	}
}

// маркер элемента списка
// function _marker(id, name) {
// 	return _string(
// 		id, 
// 		name, 
// 		{ 
// 			default:     'disc',
// 			restriction: {
// 				cardinality: 1, 
// 				enumeration: ['none', 'disc', 'square', 'circle']
// 			}
// 		});
// }

/**** Разные owl:DatatypeProperty ****/

// owl:DatatypeProperty
function _data(id, name, type, props) {
	props      = props || {};
	props.id   = id;
	props.name = name;
	props.type = type;  // rdf:range =  any xsd type
	return props;
}

// owl:DatatypeProperty +  xsd:string
function _string(id, name, props) {
	return _data(
		id, 
		name, 
		'xsd:string', 
		props);
}

// обязательная строка
function _required_string(id, name, props) {
	props = props || {};
	props.restriction = props.restriction || {};
	props.restriction.minCardinality = props.restriction.cardinality = 1;
	return _optional_string(id, name, props);
}

// необязательная строка
function _optional_string(id, name, props) {
	props = props || {};
	props.restriction = props.restriction || {};
	props.restriction.minCardinality = props.restriction.minCardinality || 0;
	props.restriction.cardinality = props.restriction.cardinality || 1;
	if (props.restriction.multiline === undefined) {
		props.restriction.multiline = false;
	}
	return _string(
		id,
		name,
		props);
}

// owl:DatatypeProperty +  xsd:positiveInteger
function _positiveInteger(id, name, props) {
	return _data(
		id, 
		name, 
		'xsd:positiveInteger', 
		props);
}

function _nonNegativeInteger(id, name, props) {
	return _data(
		id,
		name,
		'xsd:nonNegativeInteger',
		props);
}

function _boolean(id, name, unique, optional) {
	return _data(
		id, 
		name, 
		'xsd:boolean', 
		{
			default:     'false', 
			restriction: {
				unique:         unique,
				minCardinality: 0,
				cardinality:    1,
				optional:       optional
			}
		});
}
